import {
  ActionReducerMapBuilder,
  PayloadAction,
  createReducer,
} from "@reduxjs/toolkit";
import { DefaultSessionState, SessionState } from "../state/stateItems";
import { getSelfAsync, storeOrganizationId } from "../actions";
import { TUserSelf } from "@/data/types";

const handleStoreOrganizationIdAsync = (
  state: SessionState,
  action: PayloadAction<string | null>
) => {
  const id = action.payload;

  state.organizationId = id;
};

const handleGetSelfAsync = (
  state: SessionState,
  action: PayloadAction<TUserSelf | null>
) => {
  if (!action?.payload) {
    return state;
  }
  const user = action.payload;
  state.currentUser = user;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<SessionState>) => {
  builder.addCase(storeOrganizationId.type, handleStoreOrganizationIdAsync);
  builder.addCase(getSelfAsync.fulfilled.type, handleGetSelfAsync);
};

export default createReducer(DefaultSessionState, reducerBuilder);
